export default "/images/62bda65e055b224a0a2397223dc9caf9.avif";